<script setup>
import BaseLayout from '@/components/layout/BaseLayout.vue';
import { RouterView } from 'vue-router';
</script>

<template>
  <BaseLayout>
    <RouterView />
  </BaseLayout>
</template>